import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { barberRoleOptions } from '../../lib/barberRoles';
import { emptyBarber, genPw } from '../../lib/onboardShop/helpers';

export const StepBarbers = ({ barbers, setBarbers, plan, owner }) => {
  const upd = (i, patch) => setBarbers(barbers.map((b, idx) => idx === i ? { ...b, ...patch } : b));
  const rm = (i) => setBarbers(barbers.filter((_, idx) => idx !== i));
  const add = () => setBarbers([...barbers, emptyBarber()]);
  const ownerAlreadyAdded = barbers.some((b) =>
    (b.email || '').trim().toLowerCase() === (owner?.email || '').trim().toLowerCase() &&
    (owner?.email || '').trim().length > 0
  );
  const addOwnerAsBarber = () => {
    setBarbers([
      {
        ...emptyBarber(),
        name: owner?.name || 'Owner',
        role: 'Barber 1',           // Barber 1 is reserved for the shop owner
        email: owner?.email || '',
        giveLogin: false,           // owner already has a login via shop_admin
      },
      ...barbers,
    ]);
  };
  const roleOpts = barberRoleOptions(plan);
  const isOwnerRow = (b) =>
    !!b.email && !!owner?.email &&
    b.email.trim().toLowerCase() === owner.email.trim().toLowerCase();

  return (
    <>
      <h3 className="admin-info-header">Barbers</h3>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, margin: '0 0 14px' }}>
        <div className="sub" style={{ color: 'var(--mute)' }}>
          Optional. You can add barbers later from the shop dashboard.
          {owner?.email && !ownerAlreadyAdded && ' Solo-chair? Tap "Add owner as barber" — we\'ll auto-link them.'}
        </div>
        <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
          {owner?.email && !ownerAlreadyAdded && (
            <button className="btn s" onClick={addOwnerAsBarber} data-testid="wiz-barbers-add-owner">
              <Plus size={14} /> Add owner as barber
            </button>
          )}
          <button className="btn s" onClick={add} data-testid="wiz-barbers-add"><Plus size={14} /> Add barber</button>
        </div>
      </div>

      {barbers.length === 0 && <div style={{ color: 'var(--mute2)', padding: '16px 0' }}>No barbers yet.</div>}
      {barbers.map((b, i) => {
        const ownerRow = isOwnerRow(b);
        return (
          <div key={i} className="rep-card" data-testid={`wiz-barber-${i}`}>
            <div className="rep-card-h">
              <b>Barber #{i + 1}{ownerRow && <span style={{ fontWeight: 'var(--fw-regular)', color: 'var(--text-mute)', marginLeft: 8 }}>· shop owner</span>}</b>
              <button className="btn s" onClick={() => rm(i)} data-testid={`wiz-barber-remove-${i}`}><Trash2 size={14} /></button>
            </div>
            <div className="wiz-row three">
              <div className="field"><label>Name</label>
                <input className="inp" value={b.name} onChange={(e) => upd(i, { name: e.target.value })} data-testid={`wiz-barber-name-${i}`} />
              </div>
              <div className="field"><label>Role</label>
                {ownerRow ? (
                  <input className="inp" value="Barber 1" readOnly disabled title="Barber 1 is reserved for the shop owner" data-testid={`wiz-barber-role-${i}`} />
                ) : (
                  <select className="inp" value={b.role || ''} onChange={(e) => upd(i, { role: e.target.value })} data-testid={`wiz-barber-role-${i}`} aria-label="Pick a barber role">
                    <option value="">Pick a role…</option>
                    {roleOpts.map((o) => (
                      <option key={o.id} value={o.label} disabled={o.disabled || o.slot === 1}>
                        {o.label}{o.slot === 1 ? ' — reserved for owner' : o.hint}
                      </option>
                    ))}
                  </select>
                )}
              </div>
              <div className="field"><label>&nbsp;</label>
                <label style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 6 }}>
                  <input type="checkbox" checked={b.giveLogin} onChange={(e) => upd(i, { giveLogin: e.target.checked })} data-testid={`wiz-barber-givelogin-${i}`} disabled={ownerRow} />
                  <span style={{ fontSize: 'var(--fs-base)' }}>Give a login{ownerRow && <span style={{ color: 'var(--text-mute)' }}> (owner already has one)</span>}</span>
                </label>
              </div>
            </div>
            <div className="field">
              <label>Bio</label>
              <textarea className="inp" rows={2} value={b.bio} onChange={(e) => upd(i, { bio: e.target.value })} data-testid={`wiz-barber-bio-${i}`} />
            </div>
            {b.giveLogin && (
              <div className="wiz-row">
                <div className="field"><label>Email</label>
                  <input className="inp" type="email" value={b.email} onChange={(e) => upd(i, { email: e.target.value })} data-testid={`wiz-barber-email-${i}`} />
                </div>
                <div className="field"><label>Password</label>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <input className="inp" value={b.password} onChange={(e) => upd(i, { password: e.target.value })} data-testid={`wiz-barber-password-${i}`} />
                    <button type="button" className="btn s" onClick={() => upd(i, { password: genPw() })}>Regenerate</button>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};
